// Phones only: iPads report as Macintosh and Android tablets omit "Mobile".
function phonePlatform(userAgent) {
  const ua = String(userAgent || '');
  if (/iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return 'android';
  return null;
}

module.exports = { phonePlatform };
